export const summaryRows: string[] = [
  'Volume 1 — Battery Technology Fundamentals',
  'Volume 2 — Battery Chemistries & Advanced Technologies',
  'Volume 3 — Battery Management & Power Conversion Systems',
  'Volume 4 — Battery Energy Storage Systems (BESS)',
  'Volume 5 — Renewable Energy Storage & Grid Integration',
  'Volume 6 — Battery Safety, Reliability & Lifecycle Management',
  'Bonus 1 — 200 Essential Terms Glossary',
  'Bonus 2 — Battery Specifications Reference',
  'Bonus 3 — 20 Application Scenarios',
  'Bonus 4 — 75 Misconceptions Explained',
  'Bonus 5 — 12 Industry Applications Guide',
  '7-day money-back guarantee',
  'Instant access',
];
